/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, March 2023
 * @format
 * @flow
 */

import React from 'react';
import classes from './HelpPopup.module.css';
import clearWaitlistImg from '../../../../assets/images/TMS/edit-user.png';
import mergeIcon from '../../../../assets/images/TMS/merge.png';
import unmergeIcon from '../../../../assets/images/TMS/split.png';
import moveTableIcon from '../../../../assets/images/TMS/moveTable.png';
import infoIcon from '../../../../assets/images/Fireboard/infoIcon.png';
import smsIcon from '../../../../assets/images/TMS/sms.png';
import PopupHeader from '../../../Fireboard/components/PopupHeader';
import cancelWaitlistImg from '../../../../assets/images/TMS/delete.png';
import clearWaitlist from '../../../../assets/images/TMS/edit-user.png';
import clearTable from '../../../../assets/images/TMS/clearTable.png';
import editWaitlistImg from '../../../../assets/images/TMS/edit.png';
import seatPartyImg from '../../../../assets/images/TMS/seat-party.png';
import moveImg from '../../../../assets/images/TMS/move.png';
import returnWaitListImg from '../../../../assets/images/TMS/queue.png';
import strings from '../../../../globalization';

const HelpPopup = ({ onClose, headerFlow }) => {
    const config = [
        { icon: infoIcon, name: strings.checkDetailsLabel },
        { icon: unmergeIcon, name: strings.unmergeTableLabel },
        { icon: clearTable, name: strings.clearTableLabel },
        { icon: moveTableIcon, name: strings.transferTableLabel },
        { icon: mergeIcon, name: strings.mergeTableLabel },
    ]

    const headerConfig = [
        { icon: seatPartyImg, name: strings.seatPartyLabel },
        { icon: returnWaitListImg, name: strings.returnWaitlistLabel },
        { icon: editWaitlistImg, name: strings.editWaitlistLabel },
        { icon: cancelWaitlistImg, name: strings.deleteWaitlistLabel },
        { icon: smsIcon, name: strings.smsGuestLabel },
        { icon: moveImg, name: strings.reorderWaitlist },
    ]

    const configData = headerFlow ? headerConfig : config;

    return (
        <div className={classes.container}>
            <PopupHeader title={strings.helpContent} onClose={onClose} />
            <div className={classes.innerContainer}>
                <div className={classes.itemsContainer}>
                    {headerConfig.map(each => {
                        return (
                            <div className={classes.item} key={each.name}>
                                <img src={each.icon} alt={each.name} className={classes.clearWaitlist} />
                                <span className={classes.valueTextStyle}>{each.name}</span>
                            </div>
                        )
                    })}
                </div>
                <div className={classes.itemsContainer}>
                    {config.map(each => {
                        return (
                            <div className={classes.item} key={each.name}>
                                <img src={each.icon} alt={each.name} className={classes.clearWaitlist} />
                                <span className={classes.valueTextStyle}>{each.name}</span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default HelpPopup;
